import { useState } from "react";
import { Check, ChevronsUpDown, Plus } from "lucide-react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";

export const RuteCombobox = ({ options, value, onChange, placeholder, testId }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const trimmed = query.trim();
  const isNew = trimmed && !options.some((o) => o.toLowerCase() === trimmed.toLowerCase());

  const pick = (v) => {
    onChange(v);
    setQuery("");
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={(v) => { setOpen(v); if (!v) setQuery(""); }}>
      <PopoverTrigger asChild>
        <Button data-testid={testId} type="button" variant="outline" role="combobox" aria-expanded={open}
          className="w-full justify-between font-normal border-zinc-300 bg-white hover:bg-zinc-50 input-touch">
          <span className={`truncate ${value ? "" : "text-zinc-400"}`}>{value || placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 bg-white" align="start">
        <Command filter={(val, search) => (val.toLowerCase().includes(search.toLowerCase()) ? 1 : 0)}>
          <CommandInput data-testid={`${testId}-search`} placeholder="Ketik untuk mencari / tambah baru..."
            value={query} onValueChange={setQuery} />
          <CommandList>
            <CommandEmpty className="py-2 px-3 text-sm text-zinc-500">
              {trimmed ? "Belum ada di riwayat — pilih tombol di bawah." : "Belum ada riwayat."}
            </CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o} value={o} data-testid={`${testId}-item-${o.replace(/ /g, "-")}`}
                  onSelect={() => pick(o)}>
                  <Check className={`mr-2 h-4 w-4 ${value === o ? "opacity-100" : "opacity-0"}`} />
                  {o}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
          {isNew && (
            <div className="border-t border-zinc-100 p-1">
              <button type="button" data-testid={`${testId}-add-new`} onClick={() => pick(trimmed)}
                className="w-full flex items-center gap-2 px-2 py-1.5 text-sm rounded-sm text-emerald-800 hover:bg-emerald-50 transition-colors duration-150">
                <Plus className="h-4 w-4" /> Gunakan "{trimmed}"
              </button>
            </div>
          )}
        </Command>
      </PopoverContent>
    </Popover>
  );
};
